import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';

import { getCartItemData } from '../../../utilities/selectors';
import { getSymbolFromCurrency, prop } from '../../../utilities';
import { getZlataPriadkaCartProductInfo } from '../selectors';
import { CountSetter } from './CountSetter';
export interface Props {
  item: any;
  addToCart: any;
}

function MiniCartItem({ item, addToCart }: Props) {
  const { idx, picture, name, price, currency, attrib, url } = getCartItemData(
    item,
  );

  const { count: initialCount, unit } = getZlataPriadkaCartProductInfo(item);
  const [count, setCount] = React.useState(initialCount.toString());
  const step = unit === 'm' ? 0.1 : 1;

  const handleCountChange = (newCount: string) => {
    const withoutCommas = newCount.replace(',', '.');
    let newCountNumber = parseFloat(withoutCommas);

    if (isNaN(newCountNumber)) {
      setCount(newCount);
      return;
    }

    if (parseFloat(newCount) < step) {
      newCount = step.toFixed(3);
    }
    newCountNumber = parseFloat(newCount);
    const countDiff = -(initialCount - newCountNumber);
    addToCart(item, countDiff);

    setCount(newCount);
  };

  return (
    <Wrapper>
      <ImageNameWrapper>
        <ImageLink to={url}>
          <Image alt={`Obrázok ku produktu ${name}`} src={picture} />
        </ImageLink>
        <ContentWrapper>
          <NameWrapper>
            <NameLink to={url}>
              <Name>{name}</Name>
            </NameLink>
            <RightWrapper>
              <CountSetter
                onChange={handleCountChange}
                unit={unit}
                count={count}
                step={step}
              />
              <Price>{`${price ? price.toFixed(2) : 0} ${getSymbolFromCurrency(
                currency,
              )}`}</Price>
            </RightWrapper>
          </NameWrapper>
          <HelpText>{attrib}</HelpText>
        </ContentWrapper>
      </ImageNameWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  padding: ${rem(16)} 0;
  justify-content: space-between;
  border-bottom: ${rem(2)} solid #eeeeee;
`;

const RightWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const ImageNameWrapper = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;

  ${({ theme }) => theme.mediab.l1150`
    margin-right: ${rem(8)};
  `}
`;

const Image = styled.img`
  width: ${rem(48)};
  max-height: ${rem(48)};
  height: auto;
  margin-right: ${rem(16)};
`;

const NameWrapper = styled(FlexRow)`
  justify-content: space-between;
  align-items: center;
`;

const ContentWrapper = styled(FlexCol)`
  flex: 1;
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  text-decoration: none;
  color: ${({ theme }) => theme.color.textPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${rem(106)};

  ${({ theme }) => theme.mediab.s450`
    max-width: ${rem(106)};
  `}
`;

const HelpText = styled(Name)`
  font-size: ${rem(13)};
  color: ${({ theme }) => theme.color.gray48};
  margin-top: ${rem(2)};
`;

const Price = styled(TextP)`
  font-size: ${rem(14)};
  font-weight: 500;
  line-height: ${rem(21)};
  color: ${({ theme }) => theme.color.textPrimary};
  white-space: nowrap;
`;

const HighlightedText = styled.span`
  background-color: ${({ theme }) => theme.colors.highlight};
`;

const NameLink = styled(Link)`
  text-decoration: none;
`;

const ImageLink = styled(Link)`
  max-height: ${rem(48)};
  height: auto;
`;

export { MiniCartItem };
